// Today's dates on Today: a birthday, an appointment, a bill due, each once,
// on the day itself. The lead reminders are pushes; this is the day.
import { useDates } from '@/db/hooks'
import { upcomingDates } from '@/lib/dates'
import { DateRow } from './DateBits'

export const TodayDates = ({ today }: { today: string }) => {
  const on = upcomingDates(useDates(), today, 0)
  if (!on.length) return null
  return (
    <ul className="group-list mb-3" data-testid="today-dates">
      {on.map((u) => (
        <DateRow key={u.date.id} date={u.date} on={u.on} today={today} />
      ))}
    </ul>
  )
}
